import { render, staticRenderFns } from "./phone_.vue?vue&type=template&id=237021ea&"
import script from "./phone_.vue?vue&type=script&lang=js&"
export * from "./phone_.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports